import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { TimerType } from '../../types/components'

export const Bold = styled.span`
	font-weight: var(--fw-md);
`

const Timer = ({ seconds, checkTimer }: TimerType) => {
	const [timeLeft, setTimeLeft] = useState(seconds)

	useEffect(() => {
		if (!timeLeft) return
		const intervalId = setInterval(() => {
			if (timeLeft === 1) {
				checkTimer()
			}
			setTimeLeft(timeLeft - 1)
		}, 1000)
		return () => clearInterval(intervalId)
	}, [checkTimer, timeLeft])

	return <Bold>{timeLeft} sec</Bold>
}

export default Timer
